import { render } from "./PemeriksaanAi.vue?vue&type=template&id=1fa306d6"
import script from "./PemeriksaanAi.vue?vue&type=script&lang=js"
export * from "./PemeriksaanAi.vue?vue&type=script&lang=js"

import "./PemeriksaanAi.vue?vue&type=style&index=0&id=1fa306d6&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__